var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighOnInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#3FEB3C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 42C28.5 42.8284 29.1716 43.5 30 43.5C30.8284 43.5 31.5 42.8284 31.5 42L28.5 42ZM31.5 42L31.5 18L28.5 18L28.5 42L31.5 42Z",
    fill: "#059003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 27L30 18L39 27",
    stroke: "#059003",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighOnInventory);
export default __webpack_public_path__ + "static/media/High_on_Inventory.65dc9bbb21b07bf0e10d093f7619a090.svg";
export { ForwardRef as ReactComponent };